import React from "react"
import "./Education.css"
import ResumeApi from "./EducationApi"
import Card from "./card"

const Resume = () => {
  return (
    <>
      <section className='Resume' id='education'>
        <div className='container top'>
          <div className='heading text-center'>
            <h1>EDUCATION & WORK EXPERIENCE</h1>
          </div>

          <div className='content-section mtop d_flex'>
            <div className='left'>
              <div className='heading'>
                <h4>2009-PRESENT</h4>
                <h1>Education</h1>
              </div>

              <div className='content'>
                {ResumeApi.map((val, id) => {
                  if (val.category === "education") {
                    return <Card key={id} title={val.title} year={val.year} desc={val.desc} />
                  }
                })}
              </div>
            </div>
            <div className='left'>
              <div className='heading'>
                <h4>2021-PRESENT</h4>
                <h1>Work Experience</h1>
              </div>

              <div className='content'>
                {ResumeApi.map((val, index) => {
                  if (val.category === "experience") {
                    return <Card key={index} title={val.title} year={val.year} desc={val.desc} />
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="demo">

      </section> */}
    </>
  )
}

export default Resume